"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentPropsWithRef, ReactNode } from "react";
import { useRef } from "react";
import { cn } from "@/lib/utils";
import { CopyButton } from "@/ui/atoms/copy-button";
export interface CodeBlockProps extends Omit<ComponentPropsWithRef<"pre">, "children"> {
  children: ReactNode;
}
export function CodeBlock(t0) {
  const $ = _c(14);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  const codeRef = useRef(null);
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (codeRef.current) {
        const codeElement = codeRef.current.querySelector("code");
        return codeElement ? codeElement.innerText : "";
      }
      return "";
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getCode = t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn(className, "overflow-x-auto p-0");
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== rest || $[9] !== t2) {
    t3 = <pre ref={codeRef} className={t2} {...rest}>{children}</pre>;
    $[7] = children;
    $[8] = rest;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="code-header absolute top-0 right-0 cursor-pointer"><CopyButton getCodeAction={getCode} /></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3) {
    t5 = <div className="relative my-2 w-full p-0">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
CodeBlock.displayName = "CodeBlock";